// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e13e5862","239":"d85b1a52","455":"d32a7632"}[chunkId] + ".chunk.js";
};